module.exports = __webpack_public_path__ + "img/horizontal_3_4_r_pp2_3009.c6e74e1f.png";